// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2ay6V","title":"Images90_title__1jc__","images":"Images90_images__2Mq4D"};